import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/dist/client/link.js");
